<div class="container-fluid bg-gradient-primary py-4 text-white">
  <div class="row">
    @for (menu of menuData; track menu.route) {
      <app-menu-item [menuItem]="menu"></app-menu-item>
    }
  </div>
</div>
